(function () {
  'use strict';

  var navigationSelector = '[data-in-page-navigation]';

  if (window.MaxxInPageNavigation) {
    window.MaxxInPageNavigation.initAll(document);
    return;
  }

  function slugify(value) {
    var normalizedValue = value.toLowerCase();

    if (normalizedValue.normalize) {
      normalizedValue = normalizedValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return normalizedValue
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function readNumberSetting(navigation, settingName, fallback) {
    var parsedValue = parseInt(navigation.dataset[settingName], 10);
    return Number.isNaN(parsedValue) ? fallback : parsedValue;
  }

  function getLayoutRoot(sectionWrapper) {
    return sectionWrapper ? sectionWrapper.parentElement : null;
  }

  function getHeadingSelector(headingMode) {
    if (headingMode === 'selected') {
      return 'h2[data-in-page-heading], [data-in-page-heading] h2';
    }

    return 'h2';
  }

  function isHeadingIncluded(heading, headingMode) {
    if (!heading.textContent.trim() || heading.closest('[hidden], [aria-hidden="true"]')) {
      return false;
    }

    if (headingMode === 'selected') {
      return Boolean(heading.matches('[data-in-page-heading]') || heading.closest('[data-in-page-heading]'));
    }

    return !heading.closest('[data-in-page-heading-ignore]');
  }

  function findNavigationForElement(element) {
    var current = element;

    while (current && current !== document.documentElement) {
      var navigation = Array.prototype.reduce.call(current.children || [], function (found, child) {
        if (found || !child.classList || !child.classList.contains('in-page-navigation-section')) {
          return found;
        }

        return child.querySelector(navigationSelector);
      }, null);

      if (navigation) {
        return navigation;
      }

      current = current.parentElement;
    }

    return null;
  }

  function resetPageLayout(page) {
    if (!page) {
      return;
    }

    Array.prototype.forEach.call(page.children, function (child) {
      child.classList.remove('in-page-layout__full', 'in-page-layout__content');
      child.style.removeProperty('grid-row');
    });

    page.classList.remove('has-in-page-navigation');
    page.removeAttribute('data-in-page-layout');
    page.style.removeProperty('--in-page-sidebar-width');
    page.style.removeProperty('--in-page-sticky-offset');
  }

  function initializeNavigation(navigation) {
    if (!navigation || navigation.dataset.initialized === 'true') {
      return;
    }

    var sectionWrapper = navigation.closest('.in-page-navigation-section');
    var page = getLayoutRoot(sectionWrapper);
    var list = navigation.querySelector('[data-in-page-list]');
    var currentLabel = navigation.querySelector('[data-in-page-current]');
    var toggle = navigation.querySelector('.in-page-navigation__toggle');

    if (!sectionWrapper || !page || !list || !toggle) {
      return;
    }

    var sidebarWidth = readNumberSetting(navigation, 'sidebarWidth', 220);
    var stickyOffset = readNumberSetting(navigation, 'stickyOffset', 96);
    var headingMode = navigation.dataset.headingMode === 'selected' ? 'selected' : 'automatic';
    var layoutMode = navigation.dataset.layoutMode === 'bar' ? 'bar' : 'sidebar';
    var pageChildren = Array.prototype.slice.call(page.children);
    var navigationIndex = pageChildren.indexOf(sectionWrapper);
    var contentCount = Math.max(pageChildren.length - navigationIndex - 1, 1);
    var headings = [];
    var links = [];
    var generatedHeadingIds = [];
    var scrollFrame = null;

    if (navigationIndex === -1) {
      return;
    }

    navigation.dataset.initialized = 'true';
    navigation.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    list.textContent = '';
    sectionWrapper.hidden = false;
    page.classList.add('has-in-page-navigation');
    page.setAttribute('data-in-page-layout', layoutMode);
    page.style.setProperty('--in-page-sidebar-width', sidebarWidth + 'px');
    page.style.setProperty('--in-page-sticky-offset', stickyOffset + 'px');

    pageChildren.forEach(function (child, index) {
      child.classList.remove('in-page-layout__full', 'in-page-layout__content');
      child.style.removeProperty('grid-row');

      if (index < navigationIndex) {
        child.classList.add('in-page-layout__full');
        if (layoutMode === 'sidebar') {
          child.style.gridRow = index + 1;
        }
      } else if (index > navigationIndex) {
        child.classList.add('in-page-layout__content');
        if (layoutMode === 'sidebar') {
          child.style.gridRow = index;
        }
        headings = headings.concat(Array.prototype.slice.call(child.querySelectorAll(getHeadingSelector(headingMode))));
      }
    });

    if (layoutMode === 'sidebar') {
      sectionWrapper.style.gridRow = navigationIndex + 1 + ' / span ' + contentCount;
    }

    headings = headings.filter(function (heading) {
      return isHeadingIncluded(heading, headingMode);
    });

    if (headings.length === 0) {
      sectionWrapper.hidden = true;
      resetPageLayout(page);
      return;
    }

    function closeNavigation() {
      navigation.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    headings.forEach(function (heading, index) {
      var customLabel = heading.dataset.inPageLabel ? heading.dataset.inPageLabel.trim() : '';
      var headingText = customLabel || heading.textContent.trim();
      var baseId = heading.id || slugify(headingText) || 'page-section-' + (index + 1);
      var uniqueId = baseId;
      var suffix = 2;

      while (document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading) {
        uniqueId = baseId + '-' + suffix;
        suffix += 1;
      }

      if (heading.id !== uniqueId) {
        generatedHeadingIds.push({
          heading: heading,
          originalId: heading.id,
          assignedId: uniqueId
        });
      }

      heading.id = uniqueId;

      var item = document.createElement('li');
      var link = document.createElement('a');

      item.className = 'in-page-navigation__item';
      link.className = 'in-page-navigation__link';
      link.href = '#' + encodeURIComponent(uniqueId);
      link.textContent = headingText;

      link.addEventListener('click', function (event) {
        event.preventDefault();
        closeNavigation();

        heading.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });

        if (window.history && window.history.pushState) {
          window.history.pushState(null, '', '#' + encodeURIComponent(uniqueId));
        }
      });

      item.appendChild(link);
      list.appendChild(item);
      links.push(link);
    });

    function setActiveLink(activeIndex) {
      links.forEach(function (link, index) {
        var isActive = index === activeIndex;
        link.classList.toggle('is-active', isActive);

        if (isActive) {
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      });

      if (currentLabel && headings[activeIndex]) {
        var activeCustomLabel = headings[activeIndex].dataset.inPageLabel
          ? headings[activeIndex].dataset.inPageLabel.trim()
          : '';
        currentLabel.textContent = activeCustomLabel || headings[activeIndex].textContent.trim();
      }
    }

    function updateActiveLink() {
      var marker = window.innerWidth < 992 ? 154 : stickyOffset + 36;
      var activeIndex = 0;

      headings.forEach(function (heading, index) {
        if (heading.getBoundingClientRect().top <= marker) {
          activeIndex = index;
        }
      });

      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) {
        activeIndex = headings.length - 1;
      }

      setActiveLink(activeIndex);
      scrollFrame = null;
    }

    function requestActiveLinkUpdate() {
      if (scrollFrame === null) {
        scrollFrame = window.requestAnimationFrame(updateActiveLink);
      }
    }

    function handleToggleClick() {
      var isOpen = navigation.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    function handleDocumentClick(event) {
      if (!navigation.contains(event.target)) {
        closeNavigation();
      }
    }

    function handleNavigationKeydown(event) {
      if (event.key === 'Escape') {
        closeNavigation();
        toggle.focus();
      }
    }

    toggle.addEventListener('click', handleToggleClick);
    document.addEventListener('click', handleDocumentClick);
    navigation.addEventListener('keydown', handleNavigationKeydown);
    window.addEventListener('scroll', requestActiveLinkUpdate, { passive: true });
    window.addEventListener('resize', requestActiveLinkUpdate);

    navigation.inPageNavigationCleanup = function () {
      toggle.removeEventListener('click', handleToggleClick);
      document.removeEventListener('click', handleDocumentClick);
      navigation.removeEventListener('keydown', handleNavigationKeydown);
      window.removeEventListener('scroll', requestActiveLinkUpdate);
      window.removeEventListener('resize', requestActiveLinkUpdate);

      if (scrollFrame !== null) {
        window.cancelAnimationFrame(scrollFrame);
      }

      closeNavigation();
      list.textContent = '';

      generatedHeadingIds.forEach(function (entry) {
        if (entry.heading.id !== entry.assignedId) {
          return;
        }

        if (entry.originalId) {
          entry.heading.id = entry.originalId;
        } else {
          entry.heading.removeAttribute('id');
        }
      });

      delete navigation.dataset.initialized;
      navigation.inPageNavigationCleanup = null;
      resetPageLayout(page);
    };

    updateActiveLink();

    if (window.location.hash) {
      var initialTargetId = window.location.hash.slice(1);

      try {
        initialTargetId = decodeURIComponent(initialTargetId);
      } catch (error) {
        // Keep the raw fragment when it contains malformed escape sequences.
      }

      var initialTarget = document.getElementById(initialTargetId);

      if (initialTarget && headings.indexOf(initialTarget) !== -1) {
        window.requestAnimationFrame(function () {
          initialTarget.scrollIntoView({ behavior: 'auto', block: 'start' });
        });
      }
    }
  }

  function findNavigations(root) {
    var navigations = [];

    if (!root) {
      return navigations;
    }

    if (root.matches && root.matches(navigationSelector)) {
      navigations.push(root);
    }

    if (root.querySelectorAll) {
      navigations = navigations.concat(Array.prototype.slice.call(root.querySelectorAll(navigationSelector)));
    }

    return navigations;
  }

  var manager = {
    initAll: function (root) {
      findNavigations(root || document).forEach(initializeNavigation);
    },

    refresh: function (navigation) {
      if (!navigation) {
        return;
      }

      if (typeof navigation.inPageNavigationCleanup === 'function') {
        navigation.inPageNavigationCleanup();
      } else {
        delete navigation.dataset.initialized;
      }

      initializeNavigation(navigation);
    },

    teardown: function (root) {
      findNavigations(root).forEach(function (navigation) {
        if (typeof navigation.inPageNavigationCleanup === 'function') {
          navigation.inPageNavigationCleanup();
        }
      });
    }
  };

  window.MaxxInPageNavigation = manager;

  function refreshPageNavigation(event) {
    var navigation = event.target ? findNavigationForElement(event.target) : null;

    if (navigation) {
      manager.refresh(navigation);
    } else {
      manager.initAll(event.target);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      manager.initAll(document);
    });
  } else {
    manager.initAll(document);
  }

  document.addEventListener('shopify:section:load', refreshPageNavigation);
  document.addEventListener('shopify:section:reorder', function (event) {
    window.setTimeout(function () {
      refreshPageNavigation(event);
    }, 0);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var unloadedNavigation = event.target && event.target.matches && event.target.matches(navigationSelector)
      ? event.target
      : event.target && event.target.querySelector
        ? event.target.querySelector(navigationSelector)
        : null;
    var navigation = event.target ? findNavigationForElement(event.target) : null;

    if (unloadedNavigation) {
      manager.teardown(event.target);
      return;
    }

    window.setTimeout(function () {
      if (navigation) {
        manager.refresh(navigation);
      }
    }, 0);
  });
})();
